import { Link, usePage } from "@inertiajs/react"
import { LayoutAlt04, Palette, PlayCircle } from "@untitledui/icons"

import { ReplayDevTools } from "@/components/chat/ReplayDevTools"
import { ChatDevTools } from "@/components/chat/chat-dev-tools"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarTrigger,
} from "@/components/ui/sidebar"
import { useAuth } from "@/hooks/use-auth"
import {
  adminReplayIndexPath,
  playgroundPangramPath,
  playgroundPath,
  rootPath,
} from "@/routes"

import AppLogo from "./app-logo"

// Footer external links removed per app purpose

export function AppSidebar() {
  const page = usePage()
  const { isAuthenticated } = useAuth()
  const isOnChatPage = page.url === "/chat" || page.url.startsWith("/chat/")
  const isOnReplayPage = page.url.startsWith("/admin/replay")

  return (
    <Sidebar collapsible="icon" variant="inset">
      <SidebarHeader>
        <div className="flex items-center justify-between px-2">
          <SidebarMenu>
            <SidebarMenuItem>
              <SidebarMenuButton size="lg" asChild className="cursor-pointer">
                <Link href={rootPath()} prefetch>
                  <AppLogo />
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </SidebarMenu>
          <SidebarTrigger className="ml-2 hidden group-data-[collapsible=icon]:group-hover:inline-flex group-data-[state=expanded]:inline-flex" />
        </div>
      </SidebarHeader>

      <SidebarContent>
        {/* Authenticated-only features (e.g. Replay). Anonymous visitors on the
            public /chat page see the Sign in / Sign up prompt in the footer. */}
        {isAuthenticated && (
          <SidebarGroup className="px-2 pb-1">
            <SidebarGroupLabel>Admin</SidebarGroupLabel>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton asChild className="cursor-pointer">
                  <Link href={adminReplayIndexPath()} prefetch>
                    <PlayCircle />
                    <span>Replay</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton asChild className="cursor-pointer">
                  <Link href={playgroundPath()} prefetch>
                    <LayoutAlt04 />
                    <span>Components</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton asChild className="cursor-pointer">
                  <Link href={playgroundPangramPath()} prefetch>
                    <Palette />
                    <span>Theme</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroup>
        )}
      </SidebarContent>

      <SidebarFooter>
        {isOnChatPage && <ChatDevTools />}
        {isOnReplayPage && <ReplayDevTools />}
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
